var map = {
	"./AU.svg": "wmE1",
	"./CH.svg": "MyPs",
	"./DE.svg": "NIrX",
	"./FI.svg": "pWsP",
	"./FR.svg": "XUkH",
	"./GB.svg": "WMro",
	"./IE.svg": "fFnv",
	"./JP.svg": "BqOn",
	"./LU.svg": "P4Cw",
	"./NL.svg": "zsbx",
	"./NO.svg": "MbWA",
	"./SE.svg": "2J/x",
	"./US.svg": "j5yv",
	"./ZA.svg": "4fRl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jlzc";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries ^\.\/.*\.svg$
// module id = jlzc
// module chunks = 1